import { motion } from 'framer-motion';
import { AppleLogo, GooglePlayLogo } from '@phosphor-icons/react';

const CTASection = () => {
  return (
    <section 
      className="py-16 sm:py-24 bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(93, 16, 29, 0.95), rgba(93, 16, 29, 0.8)), url('https://images.unsplash.com/photo-1701596061179-9c54d9a9eaa5?w=1920&q=80')`
      }}
      data-testid="cta-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6">
            Ready to Explore <span className="italic text-gold-400">Wine Country?</span>
          </h2>
          <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
            Download the FREE Winery Finder App and discover wine tasting deals, exclusive coupons, and plan your perfect trip.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://apps.apple.com/us/app/napa-valley-winery-finder-real/id419570092"
              rel="noopener noreferrer"
              
              className="flex items-center justify-center gap-3 bg-white text-primary hover:bg-white/90 transition-colors rounded-full px-6 py-4"
              data-testid="cta-app-store"
            >
              <AppleLogo size={28} weight="fill" />
              <span className="font-serif">Download for iPhone</span>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.shoutem.n75202&hl=en"
              rel="noopener noreferrer"
              
              className="flex items-center justify-center gap-3 bg-white/10 text-white hover:bg-white/20 transition-colors rounded-full px-6 py-4 border border-white/20"
              data-testid="cta-play-store"
            >
              <GooglePlayLogo size={28} weight="fill" />
              <span className="font-serif">Download for Android</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
